import { render, staticRenderFns } from "./API-error.vue?vue&type=template&id=120c9ae8&scoped=true"
import script from "./API-error.vue?vue&type=script&lang=js"
export * from "./API-error.vue?vue&type=script&lang=js"
import style0 from "./API-error.vue?vue&type=style&index=0&id=120c9ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c9ae8",
  null
  
)

export default component.exports